import React, { useEffect, useState } from 'react';
import { CrossSellingButtonWrapper, CrossSellingContainer, CrossSellingWrapper } from './SectionCrossSelling.styles';
import { Heading } from '@uk-source-web/heading';
import { CrossSellingProps } from './SectionCrossSelling.types';
import { Button } from '@uk-source-web/button';
import axios from 'axios';
import { TError } from '@/services/error.types';
import { CossSellingProductProps, getCrossSellingProducts } from '@/services/product.services';
import { useModalContext } from '@/hooks/modal/useModal';
import CrossSellingAccordionCard from '../../Elements/CrossSellingAccordionCard/CrossSellingAccordionCard';
import { LoadingSpinner } from '@legacy-vfuk/core-loading-spinner';
import { LoadingWrapper } from '../../Elements/SWPricingCard/SWPricingCard.styles';

const SectionCrossSelling = ({ heading, labels, thumbnailIcon }: CrossSellingProps) => {
  const [crossSellingProducts, setCrossSellingProducts] = useState<CossSellingProductProps[]>([]);
  const [showAll, setShowAll] = useState(false);
  const { setErrorInfo, toggleModal } = useModalContext();
  const [loading, setLoading] = useState(true);

  const queryParams = labels?.join(',') || '';
  const hasCrossSelling = crossSellingProducts.length > 0;
  console.log('Cross selling products query params:', labels);

  useEffect(() => {
     if (!labels || labels.length === 0) {
    setLoading(false);
    return;
  }
    (async () => {
      try {
        const res = await getCrossSellingProducts(queryParams);
        if (!axios.isAxiosError(res) && res.status === 200) {
          setCrossSellingProducts(Array.isArray(res.data) ? res.data : [res.data]);
          console.log('Cross selling products response:', res.data);
          setLoading(false);
        } else if (axios.isAxiosError(res)) {
          setErrorInfo({
            statusType: (res.response?.data as { error?: string })?.error,
            statusCode:
              typeof (res.response?.data as { code?: string })?.code === 'string'
                ? Number((res.response?.data as { code?: string })?.code)
                : res.response?.status,
            requestUrl: null,
          });
          toggleModal(true, 'Error');
        }
      } catch (err) {
        setErrorInfo({
          statusType: 'An unexpected error occurred',
          statusCode: 500,
          requestUrl: null,
        });
        toggleModal(true, 'Error');
        setLoading(false);
      }
    })();
  }, [labels]);

  const visibleCards = showAll ? crossSellingProducts : crossSellingProducts.slice(0, 3);
  const handleViewMore = () => {
    setShowAll(prev => !prev);
  };
  console.log('Visible cross selling products:', visibleCards);
  return (
    <CrossSellingContainer>
      {!loading ? (
        <CrossSellingWrapper>
          {heading && <Heading justify="center">{heading}</Heading>}

           {!hasCrossSelling ? (
          <Heading justify="center" level={4}>
            No suitable cross-selling products found. Please add suitable labels.
          </Heading>
        ) : (
          <>
          {visibleCards.map(card => (
            <CrossSellingAccordionCard key={card.id} {...card} thumbnailIcon={thumbnailIcon} />
          ))}
          </>
        )}
        </CrossSellingWrapper>
      ) : (
        <LoadingWrapper>
          <LoadingSpinner appearance="secondary" size={5} />
        </LoadingWrapper>
      )}
      <CrossSellingButtonWrapper>
        {crossSellingProducts.length > 3 && (
          <Button text={showAll ? 'Show Less' : 'View All Products'} width="auto" onClick={() => handleViewMore()} />
        )}
      </CrossSellingButtonWrapper>
    </CrossSellingContainer>
  );
};

export default SectionCrossSelling;
